import moment from "moment";
import toast from "react-hot-toast";
// import { usePathname } from 'components/Navigation'

const url_api = process.env.NEXT_PUBLIC_BACKEND_URL;
const extUploadFile = {};
const fileUploadConfig = {
  allowed_types: [
    "pdf",
    "doc",
    "docx",
    "xls",
    "xls",
    "rar",
    "zip",
    "ppt",
    "pptx",
    "jpg",
    "png",
    "jpeg",
  ],
  maxSize: 5120,
  allowed_types_default: ["gif", "jpg", "jpeg", "bmp", "png", "pdf"],
};

const checkExtFileUpload = (extArr, ext) => {};

const checkIsValid = () => {};

const checkRules = () => {};

const fileToBase64 = (file) => {
  let res = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  return res.then((res) => res);
};

const urlDownload = (param) => {
  const url_backend = import.meta.env.VITE_BACKEND_URL;
  // console.log(url_backend.slice(-1))
  if (url_backend.slice(-1) == "/") {
    window.location.href = `${
      import.meta.env.VITE_BACKEND_URL
    }api/getfile${param}`;
  } else {
    window.location.href = `${
      import.meta.env.VITE_BACKEND_URL
    }/api/getfile${param}`;
  }
};

const urlPreview = (param, event) => {
  if (event && event == "is_bg_login") {
    return `${
      import.meta.env.VITE_BACKEND_URL
    }api/getfile/background_login/bg-login.png`;
  }
  return `${import.meta.env.VITE_BACKEND_URL}api/getfile${param}`;
};

const redirectAuth = async () => {
  const isLoggedIn = await getStorage("isLoggedIn");
  if (isLoggedIn === "1") {
    redirect("/dashboard");
  }
  redirect("/login");
};

export const redirect = (url) => {
  console.log("redirect", url);
  if (url.startsWith("http")) {
    window.location.href = url;
  } else {
    url = url.replace(/^\/+/, "");
    window.location.href = `${url}`;
  }
};

const errorFormMessage = (rules, column, message) => {
  rules.map((m, i) => {
    if (m[i] === column) {
      m[i] = message;
    }
  });
  return rules;
};

function getAppKey() {
  const path = window.location.pathname;
  if (path === "/user") return "user";
  if (path === "/audit") return "audit";
  return "manrisk";
}

const saveStorage = (key, data) => {
  const appKey = getAppKey();
  localStorage.setItem(key + "_" + appKey, data);
};

const getStorage = (key) => {
  const appKey = getAppKey();
  // console.log("appKey", appKey);
  // console.log("key", key);
  return localStorage.getItem(key + "_" + appKey);
};

// const clearStorage = () => localStorage.clear();
const clearStorage = () => {
  const appKey = getAppKey();
  const keys = ["user_login", "filter", "isLoggedIn", "is_arr_group"];
  keys.forEach((key) => localStorage.removeItem(key + "_" + appKey));

  // localStorage.clear();
};
// const removeStorage = (key) => localStorage.removeItem(key);
export const removeStorage = (key) => {
  const appKey = getAppKey();
  // const keys = ["user_login", "filter", "isLoggedIn", "is_arr_group"];
  localStorage.removeItem(key + "_" + appKey);

  // localStorage.clear();
};

const pageSlugParams = (slug, access_page) => {
  let pageFromSlugReady = false;
  let error = false;
  if (!access_page[slug[0]]) {
    error = true;
    return [null, null, error];
  }
  return [slug[0], slug[1], false];
};

const checkNotAuthorized = (response) => {
  if (response && response.error && parseInt(response.error) === 403) {
    clearStorage();
    redirect("/login");
  }
};

const initAccessMethod = async (
  page_url,
  params,
  paramstr,
  pathname,
  all_params
) => {
  // const pathname = usePathname()

  const page_mute_edit = [
    "risk_profile_analisa_risiko_inheren",
    "risk_profile_analisa_risiko_residual",
    "risk_profile_rencana_perlakuan_risiko",
    "risk_profile_realisasi_risiko_residual",
    "risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya",
  ];
  if (paramstr == undefined) paramstr = "";

  const path_arr = ["index", "add", "edit", "detail"];
  const user_loginObj = await getStorage("user_login");
  const user_login = JSON.parse(user_loginObj);

  let page_muted = false;
  if (pathname) {
    page_muted = checkPathnameMuted(pathname, page_mute_edit);
  }
  let path_error = true;
  let path = "index";
  let id = "";
  if (params && params.slug) {
    path = params.slug[0];
    if (params.slug[1]) {
      id = params.slug[1];
    }
  }

  if (!params) {
    path = "index";
  }

  if (path_arr[path]) path_error = false;

  for (let m in path_arr) {
    if (path_arr[m] === path) {
      path_error = false;
      break;
    }
  }

  if (path_error) {
    window.location.pathname = `/${page_url}${paramstr}`;
  }
  // console.log("page_url", page_url);
  var page_url1 = page_url;
  // if (page_url1 == "mt_risk_kriteria_dampak" && paramstr) {
  //   page_url = page_url + paramstr;
  // }
  if (
    ["mt_risk_kriteria_dampak", "kriteria_kemungkinan"].includes(page_url1) &&
    paramstr
  ) {
    page_url = page_url + paramstr;
  }

  let res = {};
  if (user_login.accessmethod[page_url]) {
    res = user_login.accessmethod[page_url];
  }

  // console.log(
  //   "user_login.accessmethod[page_url]",
  //   user_login.accessmethod[page_url]
  // );

  let btn_top = [];
  let btn_bottom = [];
  let btn_edit_delete = {};
  let editdelete = [];
  // let breadcrumbs = []

  // console.log('user_login.accessmethod[page_url]')
  // console.log(page_url)
  // console.log(user_login.accessmethod[page_url])

  // console.log("${page_url}${paramstr}", `${page_url}${paramstr}`);
  btn_edit_delete["edit"] = user_login.accessmethod[page_url]["edit"];
  btn_edit_delete["delete"] = user_login.accessmethod[page_url]["delete"];
  btn_edit_delete["add"] = user_login.accessmethod[page_url]["add"];

  if (
    path === "index" &&
    user_login.accessmethod[page_url] &&
    user_login.accessmethod[page_url]["add"] === true
  ) {
    btn_edit_delete["edit"] = user_login.accessmethod[page_url]["edit"];
    btn_edit_delete["delete"] = user_login.accessmethod[page_url]["delete"];
    btn_edit_delete["add"] = user_login.accessmethod[page_url]["add"];

    if (
      btn_edit_delete["add"] &&
      (page_url1 == "mt_risk_kriteria_dampak" ||
        page_url1 == "mt_risk_kriteria_kemungkinan")
    ) {
      btn_top.push({
        icon: "add",
        label: "Add",
        url: `/${page_url}/add`,
      });
    } else if (btn_edit_delete["add"]) {
      btn_top.push({
        icon: "add",
        label: "Add",
        url: `/${page_url}${paramstr}/add`,
      });
    }

    // console.log("btn_edit_delete[edit]", btn_edit_delete["edit"]);
    if (btn_edit_delete["edit"]) {
      // editdelete.push({ label: 'Edit', icon: 'edit', url: `${page_url}` })
      editdelete.push({
        label: "Edit",
        icon: "edit",
        url: `${page_url}${paramstr}`,
      });
    }
    if (btn_edit_delete["delete"]) {
      // editdelete.push({ label: 'Delete', icon: 'delete', url: `${page_url}` })
      editdelete.push({
        label: "Delete",
        icon: "delete",
        url: `${page_url}${paramstr}`,
      });
    }
  }
  if (
    path === "add" &&
    user_login.accessmethod[page_url]["add"] &&
    user_login.accessmethod[page_url]["add"] === true
  ) {
    if (page_muted == false) {
      btn_top.push({
        icon: "arrow_back",
        label: "Back",
        url: `/${page_url}${paramstr}`,
      });
      btn_bottom.push({
        icon: "save",
        label: "Save",
        url: `/${page_url}${paramstr}/${path}`,
      });
    }
    // btn_top.push({
    //   icon: "arrow_back",
    //   label: "Back",
    //   url: `/${page_url}${paramstr}`,
    // });
  }
  if (
    path === "edit" &&
    user_login.accessmethod[page_url]["edit"] &&
    user_login.accessmethod[page_url]["edit"] === true
  ) {
    if (page_muted == false) {
      btn_top.push({
        icon: "visibility",
        label: "Detail",
        url: `/${page_url}${paramstr}/detail/${id}`,
      });
      btn_top.push({
        icon: "arrow_back",
        label: "Back",
        url: `/${page_url}${paramstr}`,
      });
      btn_bottom.push({
        icon: "save",
        label: "Save",
        url: `/${page_url}${paramstr}/${path}`,
      });
    }
  }
  if (path === "detail") {
    if (btn_edit_delete["edit"])
      btn_top.push({
        icon: "edit",
        label: "Edit",
        url: `/${page_url}${paramstr}/edit/${id}`,
      });

    if (btn_edit_delete["delete"]) {
      if (page_url == "lost_event" || page_url == "internal_control_testing") {
        btn_top.push({
          icon: "delete",
          label: "Delete",
          onDelete: true,
          urldelete: `/${page_url}${paramstr}`,
          id,
        });
      } else {
        btn_top.push({
          icon: "delete",
          label: "Delete",
          onDelete: true,
          urldelete: `/${page_url}`,
          id,
        });
      }
    }

    btn_top.push({
      icon: "arrow_back",
      label: "Back",
      url: `/${page_url}${paramstr}`,
    });
  }

  // console.log("btn_top1");
  // console.log(path);
  // console.log(btn_top);

  // console.log('paramstr')
  // console.log(page_url)
  // console.log(paramstr)
  // if(paramstr) {

  // }

  if (all_params) {
    btn_top = [];
    btn_bottom = [];
    const btn_res = paramSpesificPage(
      all_params,
      pathname,
      path,
      btn_edit_delete
    );
    if (btn_res) {
      const { btn_top_res, btn_bottom_res } = btn_res;
      btn_top = btn_top_res;
      btn_bottom = btn_bottom_res;
    }
  }

  // console.log("btn_top2");
  // console.log(btn_top);

  res["btn_top"] = btn_top;
  res["btn_bottom"] = btn_bottom;
  res["btn_edit_delete"] = btn_edit_delete;
  res["editdelete"] = editdelete;

  // console.log('LOG=>')
  // console.log(params)
  // console.log(pathname)
  // console.log(page_muted)
  // console.log(user_login.accessmethod)
  // console.log(path_error)
  // console.log(path)
  // console.log(id)
  // console.log(page_url)
  // console.log(user_login.accessmethod[page_url])
  // console.log("LOGEND=>");
  // console.log("access_method", res);
  // console.log("LOGEND=>");
  // sessionStorage.setItem("page_url", page_url);
  if (path == "add" || path == "edit") {
    sessionStorage.setItem("path", path);
  }
  // sessionStorage.setItem("path", path);
  const access_method = res;
  // console.log('Utils=>access_method');
  // console.log(access_method);
  return { access_method, path, id };
};

const combokategoridampak = (event) => {
  let combo = {};
  if (!event) {
    combo = [];

    combo.push({ label: "Dampak Kuantitatif", value: 1 });
    combo.push({ label: "Dampak Kualitatif", value: 0 });
  } else {
    combo["0"] = "Kualitatif";
    combo["1"] = "Kuantitatif";
  }

  return combo;
};

function angkaKeHuruf(angka) {
  if (angka < 1) {
    return null;
  }
  let kodeHuruf = String.fromCharCode(96 + angka);
  return kodeHuruf;
}

const comboBK = (event) => {
  let combo = {};
  if (!event) {
    combo = [];

    combo.push({ label: "BK 1", value: "bk1" });
    combo.push({ label: "BK 2", value: "bk2" });
    combo.push({ label: "BK 3", value: "bk3" });
    combo.push({ label: "BK 4", value: "bk4" });
    combo.push({ label: "BK 5", value: "bk5" });
    combo.push({ label: "BK 6", value: "bk6" });
    combo.push({ label: "BK 7", value: "bk7" });
    combo.push({ label: "BK 8", value: "bk8" });
    combo.push({ label: "BK 9", value: "bk9" });
    combo.push({ label: "BK 10", value: "bk10" });
  } else {
    if (event == "list") {
      combo["bk1"] = "BK 1";
      combo["bk2"] = "BK 2";
      combo["bk3"] = "BK 3";
      combo["bk4"] = "BK 4";
      combo["bk5"] = "BK 5";
      combo["bk6"] = "BK 6";
      combo["bk7"] = "BK 7";
      combo["bk8"] = "BK 8";
      combo["bk9"] = "BK 9";
      combo["bk10"] = "BK 10";
    } else if (event == "combobox") {
      combo = [];

      combo.push({ text: "BK 1", value: "bk1" });
      combo.push({ text: "BK 2", value: "bk2" });
      combo.push({ text: "BK 3", value: "bk3" });
      combo.push({ text: "BK 4", value: "bk4" });
      combo.push({ text: "BK 5", value: "bk5" });
      combo.push({ text: "BK 6", value: "bk6" });
      combo.push({ text: "BK 7", value: "bk7" });
      combo.push({ text: "BK 8", value: "bk8" });
      combo.push({ text: "BK 9", value: "bk9" });
      combo.push({ text: "BK 10", value: "bk10" });
    }
  }

  return combo;
};
export const getStorageParse = (key) => {
  return JSON.parse(getStorage(key));
};
const paramSpesificPage = (all_params, pathname, path, btn_edit_delete) => {
  // btn_edit_delete["add"] = user_login.accessmethod[page_url]["add"];

  const pages = {
    risk_metrik_strategi_risiko: {
      index: ["id_register"],
      add: ["id_register", "add"],
      edit: ["id_register", "edit", "id_metrik_strategi_risiko"],
      detail: ["id_register", "detail", "id_metrik_strategi_risiko"],
    },
    risk_sasaran: {
      index: ["id_register"],
      add: ["id_register", "add"],
      edit: ["id_register", "edit", "id_sasaran"],
      detail: ["id_register", "detail", "id_sasaran"],
    },
    risk_capacity_limit: {
      index: ["id_register"],
      add: ["id_register", "add"],
      edit: ["id_register", "edit", "id_capacity_limit"],
      detail: ["id_register", "detail", "id_capacity_limit"],
    },
    risk_profile: {
      index: ["id_register"],
      add: ["id_register", "add", "jenis"],
      edit: ["id_register", "edit", "jenis", "id_risk_profile"],
      detail: ["id_register", "detail", "jenis", "id_risk_profile"],
    },
    risk_profile_analisa_risiko_inheren: {
      index: ["id_register"],
      add: ["id_register", "add", "jenis"],
      edit: ["id_register", "edit", "jenis", "id_risk_profile"],
      detail: ["id_register", "detail", "jenis", "id_risk_profile"],
    },
    risk_profile_analisa_risiko_residual: {
      index: ["id_register"],
      add: ["id_register", "add", "jenis"],
      edit: ["id_register", "edit", "jenis", "id_risk_profile"],
      detail: ["id_register", "detail", "jenis", "id_risk_profile"],
    },
    risk_profile_real_risiko: {
      index: ["id_register"],
      add: ["id_register", "add", "jenis"],
      edit: ["id_register", "edit", "jenis", "id_risk_profile"],
      detail: ["id_register", "detail", "jenis", "id_risk_profile"],
    },
    risk_profile_rencana_perlakuan_risiko: {
      index: ["id_register"],
      add: ["id_register", "add", "id_risk_profile", "jenis"],
      edit: ["id_register", "edit", "id_risk_profile", "jenis", "id_mitigasi"],
      detail: [
        "id_register",
        "detail",
        "id_risk_profile",
        "jenis",
        "id_mitigasi",
      ],
    },
    risk_profile_realisasi_risiko_residual: {
      index: ["id_register"],
      add: ["id_register", "add", "jenis"],
      edit: ["id_register", "edit", "jenis", "id_risk_profile"],
      detail: ["id_register", "detail", "jenis", "id_risk_profile"],
    },
    risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya: {
      index: ["id_register"],
      add: ["id_register", "add", "id_risk_profile", "id_mitigasi", "jenis"],
      edit: ["id_register", "add", "id_risk_profile", "id_mitigasi", "jenis"],
      detail: ["id_register", "add", "id_risk_profile", "id_mitigasi", "jenis"],
    },
  };

  const page_url = checkPathnameReady(pathname, pages);
  if (!page_url) {
    return false;
  }

  const slug = all_params.slug;
  const id_register = all_params["id_register"];
  const id = all_params["id"];

  let btn_top = [];
  let btn_bottom = [];

  if (!pages[page_url] || !pages[page_url][path]) {
    return false;
  }

  // console.log("paramSpesificPage");
  // console.log(all_params);
  // console.log(pathname);
  // console.log(path);
  // console.log(slug.length + 1 !== pages[page_url][path].length);

  // console.log(pages[page_url][path].length)
  if (slug.length + 1 !== pages[page_url][path].length) {
    return false;
  }
  // console.log("path", path);
  if (path == "add") {
    btn_top.push({
      icon: "arrow_back",
      label: "Back",
      url: `/${page_url}/${id_register}`,
    });
    if (btn_edit_delete["add"])
      btn_bottom.push({
        icon: "save",
        label: "Save",
      });
  }
  if (path == "edit") {
    let url = `/${page_url}/${id_register}`;
    slug.map((m) => {
      let mstr = m;
      if (m == "edit") {
        mstr = "detail";
      }
      url += `/${mstr}`;
    });
    btn_top.push({
      icon: "visibility",
      label: "Detail",
      url,
    });
    btn_top.push({
      icon: "arrow_back",
      label: "Back",
      url: `/${page_url}/${id_register}`,
    });

    if (btn_edit_delete["edit"])
      btn_bottom.push({
        icon: "save",
        label: "Save",
      });
  }
  if (path == "detail") {
    let url = `/${page_url}/${id_register}`;
    slug.map((m) => {
      let mstr = m;
      if (m == "detail") {
        mstr = "edit";
      }
      url += `/${mstr}`;
    });

    if (btn_edit_delete["edit"])
      btn_top.push({
        icon: "edit",
        label: "Edit",
        url,
      });

    if (btn_edit_delete["delete"]) {
      if (page_url == "risk_profile_rencana_perlakuan_risiko") {
        btn_top.push({
          icon: "delete",
          label: "Delete",
          onDelete: true,
          urldelete: `/risk_profile_mitigasi/${all_params.slug[1]}`,
          id: all_params.slug[all_params.slug.length - 1],
          urlback: `/risk_profile_rencana_perlakuan_risiko/${id_register}`,
        });
      } else if (
        page_url == "lost_event" ||
        page_url == "risk_sasaran" ||
        page_url == "risk_metrik_strategi_risiko" ||
        page_url == "risk_capacity_limit" ||
        page_url == "risk_profile"
      ) {
        btn_top.push({
          icon: "delete",
          label: "Delete",
          onDelete: true,
          urldelete: `/${page_url}/${id_register}`,
          id,
        });
      }
    }

    btn_top.push({
      icon: "arrow_back",
      label: "Back",
      url: `/${page_url}/${id_register}`,
    });
  }

  // console.log('paramSpesificPage=>')
  // console.log(btn_top)
  // console.log(btn_bottom)

  const btn_top_res = btn_top;
  const btn_bottom_res = btn_bottom;

  return {
    btn_top_res,
    btn_bottom_res,
  };
};

const checkPathnameReady = (pathname, pages) => {
  const pathname_arr = pathname.split("/");

  for (let x = 0; x < pathname_arr.length; x++) {
    if (pages[pathname_arr[x]]) {
      return pathname_arr[x];
    }
  }
  return false;
};

const checkPathnameMuted = (pathname, pagemuted) => {
  const pathname_arr = pathname.split("/");
  // console.log('checkPathnameMuted')
  // console.log(pathname_arr)
  // console.log(pagemuted)

  // let returnfnc = false
  for (let i = 0; i < pagemuted.length; i++) {
    for (let x = 0; x < pathname_arr.length; x++) {
      if (pathname_arr[x] == pagemuted[i]) {
        return true;
      }
    }
  }
  // pagemuted.forEach(m => {
  //   console.log('m')
  //   console.log(m)
  //   pathname_arr.forEach(x => {
  //     // console.log('x')
  //     // console.log(x)
  //     if (x == m) {
  //       returnfnc = true;
  //     }
  //   })
  // })
  return false;
};

const arrayToTree = (data, parentId = null) => {
  let menuTree = [];

  data.forEach((menuItem) => {
    if (menuItem.id_parent_menu === parentId) {
      const children = arrayToTree(data, menuItem.id_menu);
      if (children.length) {
        menuItem.children = children;
      } else {
        menuItem.children = [];
      }
      menuTree.push(menuItem);
    }
  });

  return menuTree;
};

const arrayToTree1 = (data, parentId = null) => {
  let menuTree = [];

  data.forEach((menuItem) => {
    menuItem.text = menuItem.nama;
    menuItem.id = menuItem.id_register;
    if (menuItem.id_parent_register === parentId) {
      const children = arrayToTree1(data, menuItem.id_register);
      if (children.length) {
        // menuItem.state = 'closed'
        menuItem.children = children;
      } else {
        if (menuItem.navigasi == "0") {
          // menuItem.state = 'closed'
          menuItem.children = [{ nama: "" }];
        } else menuItem.children = [];
      }
      menuTree.push(menuItem);
    }
  });

  return menuTree;
};
const arrayToTreeFilterRiskRegister = (data, parentId = null) => {
  let menuTree = [];

  data.forEach((menuItem) => {
    menuItem.text = menuItem.nama;
    menuItem.id = menuItem.id_register;
    menuTree.push(menuItem);
  });

  return menuTree;
};

const arrayToTree2 = (data) => {
  let menuTree = [];
  data.forEach((menuItem) => {
    menuItem.id = menuItem.id_menu;
    menuItem.text = menuItem.label;
    menuItem.checkState =
      parseInt(menuItem.selected) == 1 ? "checked" : "unchecked";
    menuItem.children = [];

    if (menuItem.action && menuItem.action.length > 0) {
      menuItem.action.map((m) => {
        menuItem.children.push({
          id: m.id_action,
          id_action: m.id_action,
          id_menu: m.id_menu,
          text: m.nama,
          checkState: parseInt(m.selected) == 1 ? "checked" : "unchecked",
        });
      });
    }

    menuTree.push(menuItem);

    if (menuItem.submenu && menuItem.submenu.length > 0) {
      const res = arrayToTree2(menuItem.submenu);
      res.map((m) => {
        menuItem.children.push(m);
      });
    }
    delete menuItem.selected;

    delete menuItem.action;
    delete menuItem.submenu;
  });
  return menuTree;
};

const arrayToTree3 = (data) => {
  let menuTree = [];
  data.forEach((menuItem) => {
    menuItem.action = [];
    menuItem.submenu = [];

    menuItem.selected = menuItem.checkState == "checked" ? 1 : 0;

    if (menuItem.children && menuItem.children.length > 0) {
      menuItem.children.map((m) => {
        if (m.id_action) {
          menuItem.action.push({
            id_action: m.id_action,
            nama: m.text,
            id_menu: m.id_menu,
            selected: m.checkState == "checked" ? 1 : 0,
          });
        }
      });
    }

    let childrenobj = [];
    if (menuItem.children && menuItem.children.length > 0) {
      menuItem.children.map((m) => {
        if (m.id_menu && !m.id_action) {
          childrenobj.push(m);
        }
      });
    }
    if (childrenobj && childrenobj.length > 0) {
      const res = arrayToTree3(childrenobj);
      res.map((m) => {
        menuItem.submenu.push(m);
      });
    }

    menuTree.push({
      id_menu: menuItem.id_menu,
      page: menuItem.text,
      action: menuItem.action,
      selected: menuItem.selected,
      submenu: menuItem.submenu,
    });

    delete menuItem.checkState;
    delete menuItem.icon;
    delete menuItem.label;
    delete menuItem.text;
    delete menuItem.id;

    delete menuItem.children;
  });

  return menuTree;
};

const arrayToTreeJabatan = (data, parentId = null) => {
  let menuTree = [];

  data.forEach((menuItem) => {
    if (menuItem.id_jabatan_parent === parentId) {
      const children = arrayToTreeJabatan(data, menuItem.id_jabatan);
      if (children.length) {
        menuItem.state = "open";
        menuItem.children = children;
      } else {
        if (menuItem.navigasi == "0") {
          menuItem.state = "open";
          menuItem.children = [{ nama: "" }];
        } else menuItem.children = [];
      }
      menuTree.push(menuItem);
    }
  });

  return menuTree;
};

const initFilterUrl = (data, customUrl) => {
  if (customUrl !== undefined) {
    return customUrl;
  }
  // if(!data.url && !data.filter) return
  // console.log('initFilterUrl')
  // console.log(data)

  let url = `${data.url}`;
  if (data.filter !== undefined) {
    url += "?";
    let dataPagin = false;
    let queryParts = [];
    if (data.filter.paginate !== undefined) {
      queryParts.push(`page=${data.filter.paginate.page}`);
      queryParts.push(`pagesize=${data.filter.paginate.pagesize}`);
      dataPagin = true;
    }

    if (data.filter.q) {
      queryParts.push(`q=${encodeURIComponent(data.filter.q)}`);
    }

    if (data.filter.order !== undefined) {
      queryParts.push(`order=${encodeURIComponent(data.filter.order)}`);
    }

    if (data.filter.filter) {
      // console.log("data.filter.filter")
      // console.log(data.filter.filter)
      const dataFilterObj = Object.entries(data.filter.filter);
      const dataFilterFil = dataFilterObj.filter(
        ([key, value]) => typeof value !== "object"
      );
      const dataFilter = Object.fromEntries(dataFilterFil);

      queryParts = queryParts.concat(
        Object.keys(dataFilter)
          .map(function (k) {
            if (Object.keys(k) !== "paginate" && dataFilter[k] !== "") {
              return (
                encodeURIComponent("q[" + k + "]") +
                "=" +
                encodeURIComponent(dataFilter[k])
              );
            }
          })
          .filter(Boolean),
      );
    }

    const topLevelFilterObj = Object.entries(data.filter);
    const topLevelFilterFil = topLevelFilterObj.filter(([key, value]) => {
      if (["paginate", "q", "order", "filter"].includes(key)) return false;
      if (typeof value === "object") return false;
      return value !== undefined && value !== null && value !== "";
    });
    const topLevelFilter = Object.fromEntries(topLevelFilterFil);

    queryParts = queryParts.concat(
      Object.keys(topLevelFilter).map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(topLevelFilter[k]),
      ),
    );

    url += queryParts.join("&");
  }
  return url;
};

const initBreadcrumbs = async (id, data) => {
  const databreadcrumbs = await handlefncgetrisk_registerid(id, [], data);
  // console.log('databreadcrumbs')
  // console.log(databreadcrumbs)

  let breadcrumbs = databreadcrumbs.reverse();
  // breadcrumbs.push({ label: 'Identifikasi Risiko' })
  return breadcrumbs;
};

const handlefncgetrisk_registerid = async (id, res, data) => {
  await handlegetrisk_registerid(id, res, data);
  return res;
};

const handlegetrisk_registerid = async (id, res, data) => {
  const response = await data.func({
    api_path: "/risk_register",
    id,
  });
  // console.log('getrisk_registerid=>parent')
  // console.log(response)

  checkNotAuthorized(response);
  if (response.error) return;

  res.push({
    label: response.nama,
    url: `/risk_profile/${response.id_register}`,
    response,
  });

  if (response.id_parent_register === null) return;

  await handlegetrisk_registerid(response.id_parent_register, res, data);
};

const createTableHeader = (headerData) => {
  let tableHead = "<thead>";

  // First row of headers
  tableHead += "<tr>";
  for (let i = 0; i < headerData.length; i++) {
    const { label, colspan, rowspan } = headerData[i];
    tableHead += `<th colspan="${colspan}" rowspan="${rowspan}">${label}</th>`;
  }
  tableHead += "</tr>";

  // Second row of headers (for rowspan = 2)
  tableHead += "<tr>";
  for (let i = 0; i < headerData.length; i++) {
    const { rowspan } = headerData[i];
    if (rowspan === 2) {
      tableHead += `<th colspan="1" rowspan="1"></th>`;
    }
  }
  tableHead += "</tr>";

  tableHead += "</thead>";
  return tableHead;
};

const showToastr = (event, message) => {
  if (event == "success") {
    toast.success(message);
  } else if (event == "error") {
    toast.error(message);
  } else {
    toast(message);
  }
};

// --primary: #0166b4;
// --sidebarColor: #15018c;
// --danger: #f12335;
// --warning: #ffd369;
// --success: #02aa02;
// --lightprimary: #afdcff;
// --info: #0166b4;
// --secondary: #1b4a6d;
// --color-text: #393e46;
// --lightsuccess: #9ff79f;
// --lightwarning: #f9f3b1;
// --lightdanger: #fba99d;
// --lightnotif: #dbfbdb;
// --greyicon: #a0a8b0;
// --grey: grey;

const colorsPallette = {
  success: "#02aa02",
  warning: "#ffd369",
  danger: "#f12335",
  info: "#0166b4",
  grey: "#a0a8b0",
  primary: "#0166b4",
  lightsuccess: "#9ff79f",
  lightwarning: "#f9f3b1",
  lightdanger: "#fba99d",
  ylw: "#FFFF00",
  grn: "#92D050",
  rd: "#FF0000",
};

const formatDateApp = (date, format) => {
  return moment(date).format(format);
};

const datacolorapply = {
  Rendah: colorsPallette.success,
  Moderate: colorsPallette.warning,
  "Hati-hati": colorsPallette.warning,
  Tinggi: colorsPallette.danger,
};

const colourkri = {
  Rendah: colorsPallette.grn,
  Moderate: colorsPallette.ylw,
  Tinggi: colorsPallette.rd,
};

const combostatuswarna = () => {
  const combo = [
    { label: "Aman", value: "Aman", colorapply: colorsPallette.success },
    {
      label: "Hati-hati",
      value: "Hati-hati",
      colorapply: colorsPallette.warning,
    },
    { label: "Bahaya", value: "Bahaya", colorapply: colorsPallette.danger },
  ];
  return combo;
};

const bulanNumbValueVar = {
  "01": "januari",
  "02": "februar",
  "03": "maret",
  "04": "april",
  "05": "mei",
  "06": "juni",
  "07": "juli",
  "08": "agustus",
  "09": "septembe",
  10: "oktober",
  11: "november",
  12: "desember",
};

const bulanTextValueVar = {
  januari: "01",
  februari: "02",
  maret: "03",
  april: "04",
  mei: "05",
  juni: "06",
  juli: "07",
  agustus: "08",
  september: "09",
  oktober: "10",
  november: "11",
  desember: "12",
};

const bulanTextVar = {
  januari: "",
  februari: "",
  maret: "",
  april: "",
  mei: "",
  juni: "",
  juli: "",
  agustus: "",
  september: "",
  oktober: "",
  november: "",
  desember: "",
};

const bulanTextToBulanNumber = (bulanText, event) => {
  return bulanTextValueVar[bulanText];
};

const bulanIntToBulanText = (bulanInt, event) => {
  let bulantextstring = "";
  Object.keys(bulanTextValueVar).map((m, i) => {
    if (parseInt(bulanTextValueVar[m]) == bulanInt) {
      bulantextstring = m;
    }
  });
  return bulantextstring;
};

const statusKriOtomatis = (item, nilai) => {
  // $status = "";
  // if ($row->polaritas == '+') {
  //     if ($nilai < $row["target_sampai"])
  //         $status = "Aman";

  //     if ($nilai >= $row["batas_atas"])
  //         $status = "Bahaya";
  // } else {
  //     if ($nilai > $row["target_mulai"])
  //         $status = "Aman";

  //     if ($nilai <= $row["batas_bawah"])
  //         $status = "Bahaya";
  // }

  // if ($row["target_mulai"] && $row["target_sampai"]) {
  //     if ($nilai > $row["target_mulai"] or $nilai < $row["target_sampai"])
  //         $status = "Aman";
  // }

  // if ($row["batas_bawah"] && $row["batas_atas"]) {
  //     if ($nilai <= $row["batas_bawah"] or $nilai >= $row["batas_atas"])
  //         $status = "Bahaya";
  // }

  // if (!$status)
  //     $status = "Hati-hati";

  // console.log('statusKriOtomatis')
  // console.log(item)
  // console.log(nilai)

  if (Object.keys(item).length == 0 || nilai === "") {
    return "";
  }

  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };

  const hasNum = (v) => toNum(v) !== null;

  // aman: "≤40";
  // bahaya: ">60";
  // batas_atas: 60;
  // batas_bawah: null;
  // hati_hati: ">40 - 60";
  // id_kpi: 12;
  // id_risk_profile: null;
  // is_kuantitatif: null;
  // jenis: "strategis";
  // keterangan: null;
  // kode: "R.F2.2";
  // nama: "% Jumlah klien dengan harga dibawah ketentuan yang berlaku";
  // nilai: "1";
  // periode_monitoring: "bulanan";
  // pic: 535;
  // polaritas: "-";
  // satuan: "%";
  // status: "Tinggi";
  // target_mulai: 40;

  let status = "";
  if (item["polaritas"] == "+") {
    if (hasNum(item["target_sampai"]) && toNum(nilai) >= toNum(item["target_sampai"])) {
      status = "Rendah";
    }
    if (hasNum(item["batas_bawah"]) && toNum(nilai) < toNum(item["batas_bawah"])) {
      status = "Tinggi";
    }
  } else if (item["polaritas"] == "-") {
    if (hasNum(item["target_mulai"]) && toNum(nilai) <= toNum(item["target_mulai"])) {
      status = "Rendah";
    }
    if (hasNum(item["batas_atas"]) && toNum(nilai) > toNum(item["batas_atas"])) {
      status = "Tinggi";
    }
  } else if (item["polaritas"] == "+-") {
    if (
      hasNum(item["target_mulai"]) &&
      hasNum(item["target_sampai"]) &&
      hasNum(item["batas_bawah"]) &&
      hasNum(item["batas_atas"])
    ) {
      if (
        toNum(nilai) >= toNum(item["target_mulai"]) &&
        toNum(nilai) <= toNum(item["target_sampai"])
      ) {
        status = "Rendah";
      } else if (
        toNum(nilai) < toNum(item["batas_bawah"]) ||
        toNum(nilai) > toNum(item["batas_atas"])
      ) {
        status = "Tinggi";
      }
    }

    // if (parseFloat(item["target_mulai"]) && parseFloat(item["target_sampai"])) {
    //   if (
    //     parseFloat(nilai) >= parseFloat(item["target_mulai"]) &&
    //     parseFloat(nilai) <= parseFloat(item["target_sampai"])
    //   ) {
    //     status = "Rendah";
    //   }
    // }

    // if (parseFloat(item["batas_bawah"]) && parseFloat(item["batas_atas"])) {
    //   if (
    //     parseFloat(nilai) <= parseFloat(item["batas_bawah"]) ||
    //     parseFloat(nilai) >= parseFloat(item["batas_atas"])
    //   ) {
    //     status = "Tinggi";
    //   }
    // }
  }

  if (status == "") {
    status = "Moderate";
  }

  return status;
};

const levelRisikoVar = (event) => {
  let dataarr = [];
  if (event == "referensi") {
    dataarr["Low"] = "Low";
    dataarr["Low to Moderate"] = "Low to Moderate";
    dataarr["Moderate"] = "Moderate";
    dataarr["Moderate to High"] = "Moderate to High";
    dataarr["High"] = "High";
  } else {
    let data = [
      { label: "Low", value: "Low", color: "green" },
      {
        label: "Low to Moderate",
        value: "Low to Moderate",
        color: "lightgreen",
      },
      { label: "Moderate", value: "Moderate", color: "yellow" },
      {
        label: "Moderate to High",
        value: "Moderate to High",
        color: "lightred",
      },
      { label: "High", value: "High", color: "red" },
    ];
    dataarr = data;
  }

  return dataarr;
};

const nilaiEksposurOtomatis = (nilai_dampak, nilai_kemungkinan) => {
  return nilai_dampak * (nilai_kemungkinan / 100);
};

const nilaiEksposurKualitatifOtomatis = (
  id_dampak,
  nilai_kemungkinan,
  master,
  nilai_sasaran
) => {
  // nilai eksposur = risklimit/100*nilai_kemungkinan*id_dampak
  const { risk_limit } = master;
  // if (!risk_limit) {
  //     return null
  // }

  if (nilai_sasaran) {
    return (
      (((parseFloat(nilai_sasaran) / 100) * parseFloat(nilai_kemungkinan)) /
        100) *
      parseFloat(id_dampak)
    );
  }
  return (
    (((parseFloat(risk_limit) / 100) * parseFloat(nilai_kemungkinan)) / 100) *
    parseFloat(id_dampak)
  );
};

const initMasterDB = async (data) => {
  const master = await initmasterlevel_risiko(data);
  return master;
};

const initmasterlevel_risiko = async (data) => {
  // const masterObj = await getStorage("master")
  // if (masterObj != null) {
  //   const master = JSON.parse(masterObj)
  //   return master
  // }
  let url = `/level_risiko/${data.id}/${data.tahun}/${
    data.jenis ? data.jenis : ""
  }`;

  let paramfunc = {
    api_path: url,
  };
  if (data.id_kriteria_dampak) {
    paramfunc.filter = {
      filter: {
        id_kriteria_dampak: data.id_kriteria_dampak,
      },
    };
  }
  const response = await data.func(paramfunc);
  // console.log('handlegetlevel_risiko=>')
  // console.log(response)

  checkNotAuthorized(response);
  if (response.error) {
    return false;
  }

  await saveStorage("master", JSON.stringify(response));
  return response;
};

const nilaiDampakOtomatis = (eksposur, nilai_kemungkinan) => {
  if (!eksposur || !nilai_kemungkinan) {
    return null;
  }
  // console.log('nilaiDampakOtomatis')
  // console.log(eksposur)
  // console.log(nilai_kemungkinan)
  return (eksposur / nilai_kemungkinan) * 100;
};

const skalaDampakOtomatis = (master, nilai, nilai_sasaran) => {
  if (Object.keys(master).length == 0) {
    return null;
  }
  const { dampak } = master;
  if (!dampak || dampak.length == 0) {
    return null;
  }
  if (nilai_sasaran) {
    for (let i = 0; i < dampak.length; i++) {
      if (
        parseFloat(nilai) >=
          (parseFloat(dampak[i].mulai) / 100) * parseFloat(nilai_sasaran) &&
        parseFloat(nilai) <=
          (parseFloat(dampak[i].sampai) / 100) * parseFloat(nilai_sasaran)
      ) {
        return dampak[i].id_dampak;
      }
      /*
      if (
        (dampak[i].id_dampak == 1
          ? true
          : parseFloat(nilai) >=
            (parseFloat(dampak[i].mulai) / 100) * parseFloat(nilai_sasaran)) &&
        (dampak[i].id_dampak == 5
          ? true
          : parseFloat(nilai) <
            (parseFloat(dampak[i].sampai) / 100) * parseFloat(nilai_sasaran))
      ) {
        return dampak[i].id_dampak;
      }
      */
    }
  } else {
    for (let i = 0; i < dampak.length; i++) {
      if (
        (dampak[i].id_dampak == 1
          ? true
          : parseFloat(nilai) >= parseFloat(dampak[i].nilai_mulai)) &&
        (dampak[i].id_dampak == 5
          ? true
          : parseFloat(nilai) < parseFloat(dampak[i].nilai_sampai))
      ) {
        return dampak[i].id_dampak;
      }
    }
  }
  return null;
};

const skalaProbabilitasOtomatis = (master, nilai) => {
  // const { kemungkinan } = await initmasterlevel_risiko(data)
  if (Object.keys(master).length == 0) {
    return null;
  }
  const { kemungkinan } = master;
  if (!kemungkinan || kemungkinan.length == 0) {
    return null;
  }
  for (let i = 0; i < kemungkinan.length; i++) {
    if (
      (kemungkinan[i].id_kemungkinan == 1
        ? true
        : parseFloat(nilai) > parseFloat(kemungkinan[i].persentase_mulai)) &&
      (kemungkinan[i].id_kemungkinan == 5
        ? true
        : parseFloat(nilai) <= parseFloat(kemungkinan[i].persentase_sampai))
    ) {
      return kemungkinan[i].id_kemungkinan;
    }
  }
  return null;
};

const skalaRisikoOtomatis = (master, id_dampak, id_kemungkinan) => {
  // console.log('skalaRisikoOtomatis')
  // console.log(id_dampak)
  // console.log(id_kemungkinan)
  // const { matrix } = await initmasterlevel_risiko(data)
  if (Object.keys(master).length == 0) {
    return null;
  }

  const { matrix } = master;
  if (!matrix || matrix.length == 0) {
    return null;
  }

  if (!id_dampak || !id_kemungkinan) {
    return null;
  }

  return matrix[id_kemungkinan][id_dampak];
  // console.log('matrix')
  // console.log(matrix)

  let hasil = null;
  Object.keys(matrix).map((m, i) => {
    Object.keys(matrix[m]).map((x, y) => {
      // console.log('===========>')
      // console.log(i)
      // console.log(m)
      // console.log(matrix[m][x])
      if (
        matrix[m][x].id_dampak == id_dampak &&
        matrix[m][x].id_kemungkinan == id_kemungkinan
      ) {
        hasil = matrix[m][x];
        return hasil;
      }
    });
  });

  return hasil;
};

const is_page_sys_menu_visible_tree = true;
const handleget_headers_params = () => {
  let params = {};
  const page = sessionStorage.getItem("page_url");
  const action = sessionStorage.getItem("path");

  if (page) {
    params.page = page;
  }
  if (action) {
    params.action = action;
  }
  params.application = 2;
  params.App = "Manrisk";

  // console.log("params header", params);

  return params;
};

const initFilterUrlLikelihood = (data, customUrl) => {
  if (customUrl !== undefined) {
    return customUrl;
  }

  let url = `${data.url}`;
  if (data.filter !== undefined) {
    url += "?";
    let queryParts = [];
    if (data.filter.paginate !== undefined) {
      queryParts.push(`page=${data.filter.paginate.page}`);
      queryParts.push(`pagesize=${data.filter.paginate.pagesize}`);
    }

    if (data.filter.q) {
      queryParts.push(`q=${encodeURIComponent(data.filter.q)}`);
    }

    if (data.filter.order !== undefined) {
      queryParts.push(`order=${encodeURIComponent(data.filter.order)}`);
    }

    if (data.filter.filter) {
      // console.log("data.filter.filter")
      // console.log(data.filter.filter)
      const dataFilterObj = Object.entries(data.filter.filter);
      const dataFilterFil = dataFilterObj.filter(
        ([key, value]) => typeof value !== "object"
      );
      const dataFilter = Object.fromEntries(dataFilterFil);

      const queryString = serialize(dataFilter);
      queryParts = queryParts.concat(
        queryString.split("&").filter(Boolean),
      );
    }

    const topLevelFilterObj = Object.entries(data.filter);
    const topLevelFilterFil = topLevelFilterObj.filter(([key, value]) => {
      if (["paginate", "q", "order", "filter"].includes(key)) return false;
      if (typeof value === "object") return false;
      return value !== undefined && value !== null && value !== "";
    });
    const topLevelFilter = Object.fromEntries(topLevelFilterFil);

    queryParts = queryParts.concat(
      Object.keys(topLevelFilter).map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(topLevelFilter[k]),
      ),
    );

    url += queryParts.join("&");
  }
  return url;
};
export const referensiSecurityPage = (menu, page, pathname_arr) => {
  const pages = {
    master: {
      list_2_page: {
        mt_sdm_jabatan: 1,
        mt_risk_capacity_limit: 1,
        mt_risk_kemungkinan: 1,
        mt_risk_dampak: 1,
        mt_status_pengajuan_penerima: 1,
        mt_status_pengajuan: 1,
        kriteria_kemungkinan: 1,
      },
      list_2_page_spesific: {
        mt_risk_matrix: 1,
        mt_risk_kriteria_dampak: 1,
        kriteria_kemungkinan: 1,
      },
    },
  };
  // console.log("referensiSecurityPage");
  //  console.log(menu);
  // console.log(page);
  // console.log(pathname_arr);

  // const topParent = findTopParentWithPage(menu, page);
  const topParent = findTopParent(menu, page);
  // console.log(topParent);
  if (topParent && topParent.page && topParent.page == "master") {
    if (
      !pages.master.list_2_page[page] &&
      !pages.master.list_2_page_spesific[page]
    ) {
      // // console.log("####111");
      let is_index = false;
      if (pathname_arr.length !== 2) {
        return { is_error: true };
      }
      if (pathname_arr.length === 2) {
        is_index = true;
      }
      if (is_index) {
        return { is_success: true };
      }

      if (
        !pathname_arr.includes("add") &&
        !pathname_arr.includes("edit") &&
        !pathname_arr.includes("detail")
      ) {
        return { is_error: true };
      }

      if (pathname_arr.includes("add") && pathname_arr.length !== 3) {
        return { is_error: true };
      }
      if (pathname_arr.includes("edit") && pathname_arr.length !== 4) {
        return { is_error: true };
      }
      if (pathname_arr.includes("detail") && pathname_arr.length !== 4) {
        return { is_error: true };
      }
      return { is_success: true };
    }
    if (pages.master.list_2_page[page]) {
      // // console.log("####222");
      let is_index = false;
      if (pathname_arr.length === 2) {
        is_index = true;
      }
      if (is_index) {
        return { is_success: true };
      }

      if (
        !pathname_arr.includes("add") &&
        !pathname_arr.includes("edit") &&
        !pathname_arr.includes("detail")
      ) {
        return { is_error: true };
      }
      if (pathname_arr.includes("add") && pathname_arr.length !== 3) {
        return { is_error: true };
      }
      if (pathname_arr.includes("edit") && pathname_arr.length !== 4) {
        return { is_error: true };
      }
      if (pathname_arr.includes("detail") && pathname_arr.length !== 4) {
        return { is_error: true };
      }
      return { is_success: true };
    }
    if (pages.master.list_2_page_spesific[page]) {
      // // console.log("####333");

      let is_index = false;
      if (pathname_arr.length === 3) {
        is_index = true;
      }
      if (is_index) {
        return { is_success: true };
      }

      if (
        !pathname_arr.includes("add") &&
        !pathname_arr.includes("edit") &&
        !pathname_arr.includes("detail")
      ) {
        return { is_error: true };
      }
      if (pathname_arr.includes("add") && pathname_arr.length !== 4) {
        return { is_error: true };
      }
      if (pathname_arr.includes("edit") && pathname_arr.length !== 5) {
        return { is_error: true };
      }
      if (pathname_arr.includes("detail") && pathname_arr.length !== 5) {
        return { is_error: true };
      }
      return { is_success: true };
    }
  }

  return { is_success: true };
};

export const menuChildWithParent = (data, targetPage) => {
  let result = null;
  data.forEach((item) => {
    if (item.sub && Array.isArray(item.sub)) {
      const child = item.sub.find((subItem) => subItem.page === targetPage);
      if (child) {
        // Jika ditemukan, simpan parent dan child-nya
        result = { parent: item, child: child, have_child: true };
      }
    }
    // Periksa jika item itu sendiri adalah target
    if (item.page === targetPage && !result) {
      result = { parent: null, child: item, have_child: false };
    }
  });
  return result;
};
export const url = import.meta.env.VITE_API_SSO;
export const url_token = import.meta.env.VITE_URL_TOKEN;
export const redirectLogin = () => {
  let id_package = getStorageParse("id_package");
  let on_register = getStorageParse("on_register");
  // console.log("on_register");
  // console.log(on_register);
  return;
  if (id_package && on_register) {
    saveStorage("on_register", "");
    navigate("/login_manrisk/" + id_package);
  } else {
    navigate("/login");
  }
};

export function findTopParent(data, targetPage) {
  let result = null;

  function traverse(menu, currentParent = null) {
    for (const item of menu) {
      if (item.page && item.page === targetPage) {
        result = currentParent;
        return;
      }

      if (item.submenu && item.submenu.length > 0) {
        traverse(item.submenu, currentParent || item);
        if (result) return;
      }
    }
  }

  traverse(data, null);
  return result;
}

export function findDeepestChild(data) {
  let deepestChild = null;
  let maxDepth = 0;

  function traverse(menu, depth = 0) {
    for (const item of menu) {
      if (!item.submenu || item.submenu.length === 0) {
        if (depth > maxDepth) {
          maxDepth = depth;
          deepestChild = item;
        }
      }

      if (item.submenu && item.submenu.length > 0) {
        traverse(item.submenu, depth + 1);
      }
    }
  }

  traverse(data);
  return deepestChild;
}
// const getStorageParse = (key) => {
//   return JSON.parse(getStorage(key));
// };

const SaveFilter = (page, data) => {
  const filter = JSON.parse(getStorage("filter") || "{}");
  filter[page] = data;
  if (Object.keys(filter[page]).length > 0) {
    for (let m in filter[page]) {
      if (
        typeof filter[page][m] === "string" &&
        filter[page][m].includes("%")
      ) {
        const str = filter[page][m];
        filter[page][m] = str.replace(/%/g, "");
      }
    }
  }
  saveStorage("filter", JSON.stringify(filter));
};

const SaveFilterAdd = (page, column, value) => {
  let filter = JSON.parse(getStorage("filter") || "{}");
  if (!filter[page]) {
    filter[page] = {};
  }
  filter[page][column] = value;
  saveStorage("filter", JSON.stringify(filter));
};

const GetFilter = (page, column = "") => {
  let filter = JSON.parse(getStorage("filter") || "{}");
  if (!filter[page]) {
    filter[page] = {};
    SaveFilter(page, {});
  }
  if (filter[page] && column) {
    return filter[page][column] || "";
  }
  return filter[page];
};

const column_kri_higher_better = [
  // 'nama',
  // 'polaritas',
  // 'satuan',
  "target_sampai",
  "batas_bawah",
  // 'keterangan'
];
const column_kri_lower_better = [
  // 'nama',
  // 'polaritas',
  // 'satuan',
  "target_mulai",
  "batas_atas",
  // 'keterangan'
];
const column_kri_stabilize = [
  // 'nama',
  // 'polaritas',
  // 'satuan',
  "target_mulai",
  "target_sampai",
  "batas_bawah",
  "batas_atas",
  // 'keterangan'
];

const polaritas_combo = [
  { label: "Higher Better", value: "+" },
  { label: "Lower Better", value: "-" },
  { label: "Stabilize", value: "+-" },
];
// const polaritas_combo_idx = {
//   "+": "Higher Better",
//   "-": "Lower Better",
//   "+-": "Stabilize",
// }

const periode_monitoring_combo = [
  { label: "Bulanan", value: "bulanan" },
  { label: "Triwulanan", value: "triwulanan" },
  { label: "Semester", value: "semester" },
];

const Kri_deskriptif_backup = (polaritas, data) => {
  let aman = "";
  let hati_hati = "";
  let bahaya = "";

  // aman
  let kode = "";
  if (polaritas == "+") {
    aman += "≥";
  } else if (polaritas == "-") {
    aman += "≤";
  } else {
    aman += "≥";
  }
  aman += data["target_mulai"];
  if (polaritas == "+-") {
    kode = "≤";
  }
  aman += data["target_sampai"] ? " - " + kode + data["target_sampai"] : "";

  // hati-hati
  kode = "";
  if (polaritas == "-") {
    hati_hati += ">";
  } else {
    hati_hati += "<";
  }
  hati_hati += data["target_mulai"];
  hati_hati += " - ";
  if (polaritas == "+-") {
    hati_hati += ">";
  }
  hati_hati += data["batas_bawah"];

  // bahaya
  kode = "";
  if (polaritas == "-") {
    bahaya += ">";
  } else {
    bahaya += "<";
  }
  bahaya += data["batas_bawah"];
  if (polaritas == "+-") {
    kode = ">";
  }
  bahaya += data["batas_atas"] ? " - " + kode + data["batas_atas"] : "";

  return { aman, hati_hati, bahaya };
};

const Kri_deskriptif = (polaritas, data) => {
  let aman = "";
  let hati_hati = "";
  let bahaya = "";

  // aman
  if (polaritas == "+") {
    //  'target_sampai',
    // 'batas_bawah',
    aman = `≥${data["target_sampai"]}`;
    hati_hati = `<${data["target_sampai"]} - ${data["batas_bawah"]}`;
    bahaya = `<${data["batas_bawah"]}`;
  }
  if (polaritas == "-") {
    // 'target_mulai',
    //   'batas_atas',
    aman = `≤${data["target_mulai"]}`;
    hati_hati = `>${data["target_mulai"]} - ${data["batas_atas"]}`;
    bahaya = `>${data["batas_atas"]}`;
  }
  if (polaritas == "+-") {
    // 'target_mulai',
    // 'target_sampai',
    // 'batas_bawah',
    // 'batas_atas',
    aman = `≤${data["target_mulai"]} - ≥${data["target_sampai"]}`;
    hati_hati = `<${data["target_mulai"]} - >${data["target_sampai"]}`;
    bahaya = `>${data["batas_bawah"]} - <${data["batas_atas"]}`;
  }

  return { aman, hati_hati, bahaya };
};

const Rp = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const number = Number(value);
  if (isNaN(number)) return value;

  return new Intl.NumberFormat("id-ID").format(number);
};

const decimal = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (isNaN(num)) return value;
  return num.toFixed(2);
};

const Statusicon = ({ status }) => {
  let bg = "#ccc";
  let symbol = "?";
  let color = "#fff";

  if (status === "Rendah") {
    bg = colorsPallette.success;
    symbol = "✓";
  } else if (status === "Tinggi") {
    (bg = colorsPallette.danger), (symbol = "✕");
  } else if (status === "Moderate") {
    (bg = colorsPallette.warning), (symbol = "!");
    color = "#000";
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 18,
        height: 18,
        borderRadius: "50%",
        backgroundColor: bg,
        color: color,
        fontSize: 12,
        fontWeight: "bold",
      }}
    >
      {symbol}
    </span>
  );
};

const threshold_combo = [
  { label: "Rendah", value: "aman", bg: "success" },
  { label: "Moderate", value: "hati_hati", bg: "warning" },
  { label: "Tinggi", value: "bahaya", bg: "danger" },
];

const status_risiko_combo = [
  { label: "Draft", value: "Draft" },
  { label: "Aktif", value: "Aktif" },
];

const ya_tidak_combo = [
  { label: "Ya", value: "Ya" },
  { label: "Tidak", value: "Tidak" },
];

const sumber_combo = [
  { label: "Internal", value: "Internal" },
  { label: "Eksternal", value: "Eksternal" },
  { label: "Internal & Eksternal", value: "Internal & Eksternal" },
];

const aspek_smki_combo = [
  { label: "Confidentiality", value: "Confidentiality" },
  { label: "Integrity", value: "Integrity" },
  { label: "Availability", value: "Availability" },
  { label: "All", value: "All" },
  { label: "N/A", value: "N/A" },
];

const penerapan_combo = [
  { label: "Selalu diterapkan", value: "Selalu diterapkan" },
  { label: "Tidak Konsisten", value: "Tidak Konsisten" },
  { label: "Tidak Diterapkan", value: "Tidak Diterapkan" },
];

const kelayakan_combo = [
  { label: "Tepat Sasaran", value: "Tepat Sasaran" },
  { label: "Kurang Tepat", value: "Kurang Tepat" },
  { label: "Lemah", value: "Lemah" },
];

const status_perlakuan_risiko_combo = [
  { label: "Monitoring", value: "Monitoring" },
  { label: "Terima", value: "Terima" },
  { label: "Mitigasi", value: "Mitigasi" },
];

const status_real_risiko_combo = [
  { label: "Progress", value: "Progress" },
  { label: "Monitoring", value: "Monitoring" },
  { label: "Selesai", value: "Selesai" },
];

export {
  status_real_risiko_combo,
  status_perlakuan_risiko_combo,
  penerapan_combo,
  kelayakan_combo,
  aspek_smki_combo,
  sumber_combo,
  ya_tidak_combo,
  status_risiko_combo,
  threshold_combo,
  periode_monitoring_combo,
  polaritas_combo,
  column_kri_higher_better,
  column_kri_lower_better,
  column_kri_stabilize,
  url_api,
  fileUploadConfig,
  Kri_deskriptif,
  checkExtFileUpload,
  angkaKeHuruf,
  checkIsValid,
  urlPreview,
  checkRules,
  urlDownload,
  errorFormMessage,
  saveStorage,
  SaveFilter,
  Rp,
  decimal,
  Statusicon,
  GetFilter,
  SaveFilterAdd,
  getStorage,
  clearStorage,
  pageSlugParams,
  checkNotAuthorized,
  initAccessMethod,
  arrayToTree,
  arrayToTree1,
  arrayToTreeJabatan,
  comboBK,
  extUploadFile,
  initFilterUrl,
  redirectAuth,
  createTableHeader,
  bulanNumbValueVar,
  combokategoridampak,
  arrayToTree2,
  arrayToTree3,
  initBreadcrumbs,
  showToastr,
  colorsPallette,
  formatDateApp,
  bulanTextVar,
  bulanTextValueVar,
  datacolorapply,
  colourkri,
  fileToBase64,
  bulanTextToBulanNumber,
  nilaiDampakOtomatis,
  bulanIntToBulanText,
  statusKriOtomatis,
  levelRisikoVar,
  nilaiEksposurOtomatis,
  combostatuswarna,
  skalaRisikoOtomatis,
  skalaDampakOtomatis,
  skalaProbabilitasOtomatis,
  initMasterDB,
  nilaiEksposurKualitatifOtomatis,
  arrayToTreeFilterRiskRegister,
  is_page_sys_menu_visible_tree,
  handleget_headers_params,
  initFilterUrlLikelihood,
  // getStorageParse,
};
